import React, { useMemo } from 'react';
import cn from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { r_check } from '@fiverr-private/icons';
import { createSanitizedMarkup } from '@fiverr-private/futile';
import { getTheme, INPUT_CHANGE_HANDLES } from '../../constants';
import classes from '../../style.module.scss';

export const useSuggestions = ({
    props,
    isMobile,
    values,
    addTag,
    className,
    inputRef,
}) => {
    const handleOnChange = (e, { method }) => {
        const handler = INPUT_CHANGE_HANDLES[method];
        handler && handler(e, props);
    };

    const renderSuggestion = ({ slug, matched }) => (
        <div
            className={cn(classes.suggestionOptionCommon, {
                [classes.suggestionOptionDesktop]: !isMobile,
            })}
        >
            {values.includes(slug) && <Icon size={12}>{r_check}</Icon>}
            <span dangerouslySetInnerHTML={createSanitizedMarkup(matched)} />
        </div>
    );

    const renderSectionTitle = ({ label, items }) =>
        items.length &&
        label && (
            <div
                className={cn(classes.suggestionsLabel, {
                    [classes.suggestionsLabelMobile]: isMobile,
                })}
            >
                {label}
            </div>
        );
    const onSuggestionSelected = (_e, { suggestion: { slug } }) => addTag(slug);
    const autosuggestInputProps = {
        ...props,
        ref: inputRef,
        onChange: handleOnChange,
        'data-lpignore': 'true',
    };

    const theme = useMemo(
        () => ({ ...getTheme(isMobile), container: className }),
        [className, isMobile]
    );

    return {
        theme,
        autosuggestInputProps,
        onSuggestionSelected,
        renderSectionTitle,
        renderSuggestion,
    };
};
